import { takeLatest, select, call, apply, put } from 'redux-saga/effects';
import * as types from '../constants/actionTypes';
import * as account from '../api/accountApi';
import { logAPI } from "../api/andyliticsApi";
import * as portalApi from "../api/portalApi";

export default function* commonSaga() {
    yield takeLatest(types.GET_USER_NOTIFICATION_PREFERENCE, handleNotificationPreference,
        account.getNotificationPreference, 'MBHWeb.Saga.Notifications.GetUserNotificationPreference');
    yield takeLatest(types.PHARMACY_NOTIFICATION_PREFERENCE_SAVE, handleNotificationPreference,
        account.saveNotificationPreference, 'MBHWeb.Saga.Rx.Notifications.UpdateCommunicationPreference');
    //yield takeLatest(types.CARE_COACH_NOTIFICATION_PREFERENCE_SAVE, handleNotificationPreference,
    //    account.saveNotificationPreference, 'MBHWeb.Saga.CareCoach.Notifications.UpdateCommunicationPreference');
    yield takeLatest(types.GENERAL_NOTIFICATION_PREFERENCE_SAVE, handleNotificationPreference,
        account.saveNotificationPreference, 'MBHWeb.Saga.General.Notifications.UpdateCommunicationPreference');
    yield takeLatest(types.GET_APP_UPDATE, handleAppUpdates);
}

function* handleNotificationPreference(apiCall, andyliticsLogName, action) {
    const type = action.type;
    const domainData = yield select((state) => state.domain);

    try {
        if (!action.success && !action.error) {
            if (type === types.GET_USER_NOTIFICATION_PREFERENCE) { // to clear previous error state (if any)
                yield put({ type: types.PHARMACY_NOTIFICATION_PREFERENCE_SAVE, success: true, data: null });
                //yield put({ type: types.CARE_COACH_NOTIFICATION_PREFERENCE_SAVE, success: true, data: null });
                yield put({ type: types.GENERAL_NOTIFICATION_PREFERENCE_SAVE, success: true, data: null });
            }
            yield call(handle, apiCall, domainData.t, andyliticsLogName, action);
        }
    }
    catch (error) {
        console.error(error);
    }
}

export function* handle(apiCall, authToken, andyliticsLogName, action) {
    const type = action.type;
    const start = new Date();
    const data = action.data;

    try {
        let response = null;
        if (typeof data === 'object') {
            const args = [authToken];
            for (let i in data) {
                args.push(data[i]);
            }
            response = yield apply(null, apiCall, args);
        }
        else {
            response = yield call(apiCall, authToken, data);
        }

        if (andyliticsLogName) {
            logAPI(andyliticsLogName, start, null, response && response.ProxyRequestId ? JSON.parse(JSON.stringify({ ProxyRequestId: response.ProxyRequestId })) : "");
        }

        //optional Callback if needed
        if (action && action.callback) {
            action.callback("success", response);
        }

        yield put({
            type: type,
            success: true,
            data: response
        });

    }
    catch (error) {
        console.error(error);

        if (andyliticsLogName) {
            logAPI(andyliticsLogName + '.Failure', start, null, error);
        }

        //optional Callback if needed
        if (action && action.callback) {
            action.callback("failure", error ? error : null);
        }

        if (error !== null && error.status !== 401) {
            yield put({ type: type, failure: true, error: error });
        }

    }
}

function* handleAppUpdates() {
    const domainData = yield select((state) => state.domain);

    try {
        var result = yield call(handle,
            portalApi.getAppUpdate,
            domainData.t,
            'MBHWeb.Saga.GetAppUpdate',
            { type: types.GOT_APP_UPDATE });
    }
    catch (error) {
        console.error(error);
    }
}